
import { Component, forwardRef, KeyValueDiffers, Inject, OnChanges, OnInit, ElementRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

import { BlockComponent } from '../../../PageBuilder/components/Block/block.component';
import { AbstractPageBuilderService } from '../../../PageBuilder/services/abstract-page-builder.service';
import { ReportsSeriesPreviewService } from '../../../Reports/services/report-series-preview.service';
import { ReportsChartOptionsService } from '../../../Reports/services/reports-chart-options.service';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { MonitorConfigService } from '../../../MonitorShared/services/monitor-config.service';
import { UserPreferencesService } from '../../../../Account/UserPreferences/services/user-preferences.service';
import { ClickOutsideService } from '../../../PageBuilder/services/click-outside.service';
import { ReportsChartDetailService } from '../../../Reports/services/reports-chart-detail.service';
import { SocialChartDetailsDialogService } from '../../../../Social/Intelligence/services/social-chart-details-dialog.service';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { TopPostChartBlockComponent } from '../../../Reports/components/TopPostChartBlock/top-post-chart-block.component';
import { DataConnectionService } from '../../../../Core/Users/services/data-connection.service';
import { ReportsChartSeriesConverterService } from '../../../Reports/services/reports-chart-series-converter.service';
import { ReportsSeriesPreviewNewService } from '../../../../Common/Reports/services/reports-series-preview-new.service';

@Component({
    selector: 'agpr-dashboard-top-posts-chart-block',
    templateUrl: './dashboard-top-posts-chart-block.component.html',
    styleUrls: ['./dashboard-top-posts-chart-block.component.scss'],
    providers: [
        {
            provide: BlockComponent,
            useExisting: forwardRef(() => DashboardTopPostsChartBlockComponent)
        }
    ],
    standalone: false
})
export class DashboardTopPostsChartBlockComponent extends TopPostChartBlockComponent implements OnChanges, OnInit, OnDestroy {

    constructor(
        public differs: KeyValueDiffers,
        public pageBuilderService: AbstractPageBuilderService,
        public reportSeriesPreviewService: ReportsSeriesPreviewService,
        public reportsChartOptionsService: ReportsChartOptionsService,
        public elementRef: ElementRef,
        public localizationService: LocalizationService,
        @Inject(APP_BASE_HREF) public appBaseHref: string,
        public changeDetectorRef: ChangeDetectorRef,
        public userStateService: CurrentUserStateService,
        public monitorConfigService: MonitorConfigService,
        protected userPreferencesService: UserPreferencesService,
        public clickOutsideService: ClickOutsideService,
        public reportsChartDetailService: ReportsChartDetailService,
        public socialChartDetailsDialogService: SocialChartDetailsDialogService,
        public configService: ConfigService,
        public dataConnectionService: DataConnectionService,
        public reportsChartSeriesConverterService: ReportsChartSeriesConverterService,
        public reportsSeriesPreviewNewService: ReportsSeriesPreviewNewService
    ) {
        super(
            differs,
            pageBuilderService,
            reportSeriesPreviewService,
            reportsChartOptionsService,
            elementRef,
            localizationService,
            appBaseHref,
            changeDetectorRef,
            userStateService,
            monitorConfigService,
            userPreferencesService,
            clickOutsideService,
            reportsChartDetailService,
            socialChartDetailsDialogService,
            configService,
            dataConnectionService,
            reportsChartSeriesConverterService,
            reportsSeriesPreviewNewService
        );
    }

    ngOnChanges(): void {
        super.ngOnChanges();
    }
}
